const extraProcessSaveProductInput = (input) => input;

export default extraProcessSaveProductInput;
